import { render } from "./CoursePlaceOrder.vue?vue&type=template&id=a7090376&scoped=true"
import script from "./CoursePlaceOrder.vue?vue&type=script&lang=js"
export * from "./CoursePlaceOrder.vue?vue&type=script&lang=js"

import "./CoursePlaceOrder.vue?vue&type=style&index=0&id=a7090376&scoped=true&lang=css"

import exportComponent from "D:\\京欣医疗用户端\\login_init\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7090376"]])

export default __exports__